import { render, staticRenderFns } from "./TransactionVolumeWidget.vue?vue&type=template&id=3e2921dc&scoped=true&"
import script from "./TransactionVolumeWidget.vue?vue&type=script&lang=js&"
export * from "./TransactionVolumeWidget.vue?vue&type=script&lang=js&"
import style0 from "./TransactionVolumeWidget.vue?vue&type=style&index=0&id=3e2921dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2921dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VBtnToggle,VIcon,VProgressCircular})
